import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const LanguagesList = Loadable(lazy(() => import("features/language/components/List")));
const LanguagesPage = Loadable(lazy(() => import("features/language/components/Page")));


const routes = {
  path: "language",
  children: [
    { path: "", element: <LanguagesList /> },
    { path: "add", element: <LanguagesPage /> },
    { path: "edit/:languageID?", element: <LanguagesPage /> },
  ],
};

export default routes;
